'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import Html from 'ContentComponents/cmv2/fields/Html';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { HTML } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';
import FormControlWithErrors from 'DesignEditorsUI/components/customWidgetEditor/sidebar/FormControlWithErrors';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

class HtmlContentOptions extends Component {
  constructor(props) {
    super(props);
    this.onDefaultChange = this.onDefaultChange.bind(this);
  }

  onDefaultChange(value) {
    this.props.editField({
      [DEFAULT]: value
    });
  }

  render() {
    const {
      field,
      fieldErrors
    } = this.props;
    return /*#__PURE__*/_jsx(FormControlWithErrors, {
      errors: fieldErrors[DEFAULT],
      label: text(i18nKey(`defaultLabels.${HTML}`)),
      children: /*#__PURE__*/_jsx(SidebarInput, {
        inputComponent: Html,
        onFieldChange: this.onDefaultChange,
        value: field[DEFAULT]
      })
    });
  }

}

HtmlContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  fieldErrors: PropTypes.object
};
HtmlContentOptions.defaultProps = {
  fieldErrors: {}
};
export default HtmlContentOptions;